import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';

@Component({
  selector: 'lum-purchase-order-item-lot-dropdown',
  templateUrl: './purchase-order-item-lot-dropdown.component.html',
  styleUrls: ['./purchase-order-item-lot-dropdown.component.scss'],
})
export class PurchaseOrderItemLotDropdownComponent {
  @Input()
  index :number;

  @Input()
  item :AbstractControl;

  @Input()
  paginationLength :number;

  @Input()
  purchaseOrderItemField :string;

  @Input()
  isLotsLoading :boolean;

  @Input()
  lotsByRfqId :{
    [rfqId :string] :{
      id :number;
      rfq_id :number;
      lot_number :string;
      manufacturer_code :string;
      original_quantity :number;
      production_date :Date;
      expiry_date :Date;
    }[];
  } = {};

  @Output()
  editLineItem :EventEmitter<any> = new EventEmitter();

  @Output()
  selectLotEvent :EventEmitter<any> = new EventEmitter();

  @Output()
  openLotListEvent :EventEmitter<any> = new EventEmitter();

  onEditLineItem(field :string, index :number) {
    this.editLineItem.emit({ field, index });
  }

  onSelectLotEvent(
    event :any,
    index :number,
    lotId :number,
    matSelectComponent :MatSelect,
  ) {
    this.selectLotEvent.emit({ event, index, lotId, matSelectComponent });
  }

  onOpenLotListEvent(event :any, index :number) {
    this.openLotListEvent.emit({ event, index });
  }
}
